export const DESIGN_MODES = {
  COLLAGES: 'COLLAGES',
  SAVE_THE_DATE: 'SAVE_THE_DATE',
  ID_CARDS: 'ID_CARDS',
};
